import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    TouchableOpacity,
    StyleSheet
} from 'react-native';

import {
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib';

import { pt, px, mta, is_web } from '../../common/utils';

import img from '../../common/img';

class MovieItem extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { movieInfo } = this.props;

        return (
            <View style={ st.movie_item }>
                <View style={ st.movie_item_wrap }>
                    <TouchableOpacity
                        style={ { flexDirection: 'row' } }
                        activeOpacity={ 0.5 }
                        onPress={ () => this.goMovieDetail() }
                    >
                        <JDImage
                            style={ st.item_img }
                            source={ { uri: movieInfo.jdPicUrl } }
                        />
                        <View style={ st.item_info }>
                            <View style={ { flexDirection: 'row', alignItems: 'center' } }>
                                <JDText numberOfLines={ 1 } style={ st.movie_name }>{movieInfo.movieName}</JDText>
                                {!!movieInfo.showType && movieInfo.showType.split('-').length == 1 &&
                                    <View style={ st.movie_type_one_wrap }>
                                        <JDText style={ st.movie_type_one }>{movieInfo.showType}</JDText>
                                    </View>
                                }
                                {!!movieInfo.showType && movieInfo.showType.split('-').length == 2 &&
                                    <View style={ { flexDirection: 'row', height: pt(15), alignItems: 'center' } }>
                                        <JDText style={ st.movie_type_left }>{movieInfo.showType.split('-')[0]}</JDText>
                                        <JDText style={ st.movie_type_right }>{movieInfo.showType.split('-')[1]}</JDText>
                                    </View>
                                }
                            </View>
                            {movieInfo.grade
                                ? <JDText style={ st.movie_fen }>观众评分 {movieInfo.grade}</JDText>
                                : <JDText style={ st.movie_fen }>暂无评分</JDText>
                            }
                            <JDText numberOfLines={ 1 } style={ st.movie_actor }>主演: {movieInfo.actors ? movieInfo.actors : '未知'}</JDText>
                            {movieInfo.planCount
                                ? <JDText numberOfLines={ 1 } style={ st.movie_plan }>
                                    今天{movieInfo.cinemaCount}家影院放映{movieInfo.planCount}场
                                </JDText>
                                : <JDText numberOfLines={ 1 } style={ st.movie_plan }>今天暂无放映计划</JDText>
                            }
                        </View>
                    </TouchableOpacity>
                    <TouchableOpacity
                        activeOpacity={ 0.5 }
                        style={ st.go_buy_wrap }
                        onPress={ () => this.goBuy() }
                    >
                        <JDImage style={ st.movie_item_goBuy } source={ movieInfo.existPromtion ? img.discount : img.go_buy } />
                        <View style={ st.go_buy_text_wrap }>
                            <JDText style={ [st.go_buy_text, { marginTop: pt(4) }] }>{movieInfo.existPromtion ? '特惠' : '购票'}</JDText>
                        </View>
                    </TouchableOpacity>
                </View>
            </View>
        );
    }

    goMovieDetail() {
        const { movieInfo } = this.props;

        const { from, saveWordAndJump } = this.props;

        const { movieId, jSkuId, weight } = movieInfo;

        if (from === 'search') {
            mta('SearchListItem', 'Search', `${jSkuId}_${movieId}`);
            if (saveWordAndJump) {
                saveWordAndJump(movieInfo, 'detail');

                return;
            }
        }
        if (from === 'allMovie') {
            mta('ListMovPic', 'MovList', `${jSkuId}_${movieId}_${weight}`);
        }

        this.context.router.toMovieDetail({ movieId });
    }

    goBuy() {
        const { movieInfo } = this.props;

        const { from, saveWordAndJump } = this.props;

        const { movieId, jSkuId, existPromtion } = movieInfo;

        const str = existPromtion ? '特惠' : '购票';

        if (from === 'search') {
            mta('SearchListItem', 'Search', `${jSkuId}_${movieId}`);
            if (saveWordAndJump) {
                saveWordAndJump(movieInfo, 'buy');

                return;
            }
        }
        if (from === 'allMovie') {
            mta('ListMovBuy', 'MovList', str);
        }

        this.context.router.toMovieSchedule({ movieId });
    }
}

MovieItem.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    movie_item: {
        paddingTop: pt(14),
        paddingLeft: pt(15),
        paddingRight: pt(10),
        // paddingHorizontal: pt(10),
        backgroundColor: '#fff'
    },
    movie_item_wrap: {
        paddingBottom: pt(14),
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,0.1)',
        flexDirection: 'row'
    },
    item_img: {
        height: pt(88),
        width: pt(60),
        borderRadius: pt(3)
    },
    item_info: {
        width: pt(220),
        marginLeft: pt(14),
        justifyContent: 'space-between',
        paddingVertical: pt(4)
    },
    movie_name: {
        fontSize: pt(14),
        fontWeight: 'bold',
        marginRight: pt(8),
        maxWidth: pt(180)
    },
    movie_type_one_wrap: {
        paddingHorizontal: pt(3),
        borderRadius: pt(3),
        backgroundColor: '#898989'
    },
    movie_type_one: {
        fontSize: pt(11),
        color: '#fff',
        backgroundColor: 'transparent'
    },
    movie_type_left: {
        height: pt(15),
        fontSize: pt(11),
        paddingHorizontal: pt(3),
        borderTopLeftRadius: pt(3),
        borderBottomLeftRadius: pt(3),
        color: '#fff',
        backgroundColor: '#898989'
    },
    movie_type_right: {
        height: pt(15),
        fontSize: pt(11),
        paddingHorizontal: pt(3),
        color: '#898989',
        backgroundColor: '#fff',
        borderTopRightRadius: pt(3),
        borderBottomRightRadius: pt(3),
        borderWidth: 1,
        borderColor: '#979797'
    },
    movie_fen: {
        color: '#FFAE18',
        fontSize: pt(11),
        fontWeight: 'bold'
    },
    movie_actor: {
        color: '#666',
        fontSize: pt(12)
        // marginTop: pt(8),
        // marginBottom: pt(4),
    },
    movie_plan: {
        color: '#898989',
        fontSize: pt(11)
    },
    go_buy_wrap: {
        marginTop: pt(5),
        height: pt(30),
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center'
    },
    movie_item_goBuy: {
        width: pt(52),
        height: pt(26)
    },
    go_buy_text_wrap: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        alignItems: 'center',
        justifyContent: 'center'
    },
    go_buy_text: {
        color: '#fff',
        fontSize: pt(13),
        // fontWeight: 'bold',
        backgroundColor: 'transparent'
    }
});

export default MovieItem;
